import { useEffect, useState } from 'react';

import { Input } from 'components/common/form/input';
import { StyledLabel } from './retire-card.style';

const RetireInputName = ({ dispatch }) => {
  const [amountValue, setAmountValue] = useState('');

  useEffect(() => {
    dispatch(amountValue);
  }, [amountValue]);

  return (
    <div>
      <StyledLabel>
        Which organization would you like to retire these OCCs under?
      </StyledLabel>
      <Input
        variant="primary"
        autoComplete="off"
        autoCorrect="off"
        autoCapitalize="off"
        placeholder="Recipient Name"
        value={amountValue}
        onChange={(e) => setAmountValue(e.target.value)}
        required
      />
    </div>
  );
};

export default RetireInputName;
